import TooltipHover from "@/components/ui/TooltipHover";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

interface Props {
  apiKey: string;
}

function APIKeyValueCell({ apiKey }: Props) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="grid grid-cols-[1fr_32px] gap-x-2 font-mono">
      {isVisible && (
        <TooltipHover text={apiKey} placement="bottom" asChild>
          <span className="font-mono flex items-center">{apiKey}</span>
        </TooltipHover>
      )}
      {!isVisible && (
        <div className="col-start-1 flex items-center gap-0.5">
          {apiKey.replaceAll(/./g, "•")}
        </div>
      )}
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsVisible((prev) => !prev)}
      >
        {isVisible ? <Eye size={14} /> : <EyeOff size={14} />}
      </Button>
    </div>
  );
}

export default APIKeyValueCell;
